// extracted by mini-css-extract-plugin
export var col = "index-module--col--oosQW";
export var cols = "index-module--cols--7LcVq flex";
export var maxMd = "(max-width: 48em)";
export var section = "index-module--section--b6UnX section";